import React from 'react';
import Loadable from 'react-loadable';
import LoadingPage from '../pages/Loading';
import { useAuthStatusReducer } from '../../reducers/authStatus';

const PlatformRoutes = Loadable({
  loader: () => import('./platform'),
  loading: LoadingPage,
});

const InstitutionRoutes = Loadable({
  loader: () => import('./institution'),
  loading: LoadingPage,
});

const PublicRoutes = Loadable({
  loader: () => import('./public'),
  loading: LoadingPage,
});

export default function Routes() {
  const { status } = useAuthStatusReducer();

  if (status.authorized) {
    if (status.platformUser) {
      console.log('show as platform');
      return <PlatformRoutes />;
    }
    console.log('show as institution');
    return <InstitutionRoutes />;
  }

  console.log('show as public');
  return <PublicRoutes />;
}
